import React from "react";
import img from "../../assets/features.webp";
import styles from "./index.module.css";

const PosViewSection = () => {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>Interface</div>
      <div className={styles.subHeading}>
        So Intuitive That Anyone Can Master It In Minutes
      </div>
      <div className={styles.imageDiv}>
        <img className={styles.posImage} src={img} alt="" loading="lazy" />
      </div>
    </div>
  );
};

export default PosViewSection;
